import { Box, Heading, Text, type TextRef } from '../../../../../../mads';
import { useI18n } from '../../../../../../shared/I18n';
import useFocusOnNavigation from '../../../../hooks/useFocusOnNavigation';
import { CloseButton } from '../CloseButton';

import { useNavigation } from '@react-navigation/native';
import React, { useRef } from 'react';
import { StyleSheet } from 'react-native';

export function AIDisclaimerModal() {
    const gt = useI18n();
    const navigation = useNavigation();
    const titleRef = useRef<TextRef>(null);

    // Focus the title when the screen comes into focus for better accessibility
    useFocusOnNavigation(titleRef);

    const handleDismiss = () => {
        navigation.goBack();
    };

    return (
        <Box sx={styles.container}>
            {/* Header */}
            <Box sx={styles.header}>
                <Text
                    ref={titleRef}
                    sx={styles.headerTitle}
                    accessible={true}
                    accessibilityRole="header"
                >
                    <Heading level={3}>{gt.gettext('How this content is generated')}</Heading>
                </Text>
                <CloseButton onPress={handleDismiss} accessibilityLabel={gt.gettext('Close')} />
            </Box>

            {/* Content */}
            <Box sx={styles.content}>
                <Text level={3}>
                    {gt.gettext(
                        'Job responsibilities information is AI-generated using the job description. Please review the full job description for accuracy.',
                    )}
                </Text>
            </Box>
        </Box>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 16,
        paddingTop: 16,
        paddingBottom: 8,
    },
    headerTitle: {
        flex: 1,
        paddingRight: 10,
    },
    content: {
        paddingTop: 8,
        paddingLeft: 16,
        paddingRight: 16,
    },
});
